module.exports = __webpack_public_path__ + "img/hans-granerud-p.e231248b.webp";